<template>
  <b-modal
    :id="id"
    :ok-title="trans('save')"
    :ok-disabled="!canSave"
    :cancel-title="trans('cancel')"
    @shown="onShown"
    @hidden="onHidden"
    @ok="onSave"
  >
    <template #modal-title>
      <span v-if="!!location" class="d-block">
        {{ location.name }}
        <small class="text-muted">
          #{{ location.id }}
        </small>
      </span>
      <small v-if="!!location.alias || !!location.sku" class="d-block text-muted">
        {{ compact([location.alias, location.sku]).join(', ') }}
      </small>
    </template>

    <h5>{{ trans('status') }}</h5>

    <div v-if="!!location" class="mt-3">
      <strong class="d-block mb-1">{{ trans('operation') }}</strong>
      <b-form-radio-group stacked v-model="operation" @change="onChangeOperation">
        <b-form-radio v-if="!location.disabled_at" value="disable">
          <span class="text-danger">
            {{ trans('make_unavailable') }}
          </span>
        </b-form-radio>
        <b-form-radio v-if="!!location.disabled_at" value="enable">
          <span class="text-success">
            {{ trans('make_available') }}
          </span>
        </b-form-radio>
      </b-form-radio-group>
    </div>
    <div v-if="operation == 'disable'" class="mt-2">
      <p>
        {{ trans('make_unavailable_location_about') }}
      </p>
      <b-form-group :label="trans('title')">
        <b-form-input
          v-model="disabled_title"
          :disabled="busy"
        />
      </b-form-group>
      <b-form-group :label="trans('admin_note')">
        <b-form-textarea
          v-model="disabled_note"
          :disabled="busy"
        ></b-form-textarea>
      </b-form-group>
      <b-row class="mt-2">
        <b-col>
          <b-form-group :label="trans('end')">
            <datetime
              v-model="end_date"
              class="form-control-sm"
              :config="dateOptions"
              :placeholder="trans('end_date')"
              :disabled="busy"
            ></datetime>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group :label="trans('time')">
            <datetime
              v-model="end_time"
              class="form-control-sm"
              :config="timeOptions"
              :placeholder="trans('end_time')"
              :disabled="busy"
            ></datetime>
            <b-form-text v-if="!!humanDuration">
              {{ humanDuration }}
            </b-form-text>
          </b-form-group>
        </b-col>
      </b-row>
    </div>
    <div v-if="operation == 'enable'" class="mt-2">
      <p>
        {{ trans('make_available_location_about') }}
      </p>
    </div>

    <p v-if="busy">
      <i class="fa fa-fw fa-circle-notch fa-spin"></i>
      {{ trans('please_wait') }}
    </p>
    <p v-if="error" class="text-danger">
      {{ error }}
    </p>
  </b-modal>
</template>

<script>
  import Datetime from 'vue-bootstrap-datetimepicker'

  let dateFormat = 'ddd LL'
  let timeFormat = 'LT'

  export default {
    props: {
      id: {
        type: String,
        default: 'location-state-modal',
      },
      organization: Object,
      location: Object,
    },
    components: {
      Datetime,
    },
    data() {
      return {
        trans: trans,
        compact: _.compact,
        busy: false,
        error: null,
        operation: null,
        disabled_at: null,
        disabled_by_booking_id: null,
        disabled_by_booking: null,
        disabled_by_user_id: null,
        disabled_by_user: null,
        disabled_title: null,
        disabled_note: null,
        end_date: null,
        end_time: null,
        dateOptions: {
          locale: window.lang,
          format: dateFormat,
        },
        timeOptions: {
          locale: window.lang,
          format: timeFormat,
        },
      }
    },
    computed: {
      end() {
        if (!this.end_date || !this.end_time) return null
        let end = moment(this.end_date, dateFormat)
        let time = moment(this.end_time, timeFormat)
        end.set({
          hour: time.get('hour'),
          minute: time.get('minute'),
        })
        return end
      },
      humanDuration() {
        if (!this.end) return null
        let minutes = this.end.diff(moment(), 'minutes')
        if (Math.abs(minutes) <= 1) return trans('now')
        return moment.duration(minutes, 'minutes').humanize()
      },
      canSave() {
        return this.operation == 'disable' && !!this.disabled_title && !!this.disabled_note && !!this.end_date ||
          this.operation == 'enable'
      },
    },
    methods: {
      onChangeOperation() {
        let end = moment().add(1, 'day')
        this.end_date = end.format(dateFormat)
        this.end_time = end.format(timeFormat)
      },
      onShown() {
        this.disabled_at = this.location.disabled_at
        this.disabled_note = this.location.disabled_note
        this.disabled_by_booking_id = this.location.disabled_by_booking_id
        this.disabled_by_user_id = this.location.disabled_by_user_id
      },
      onHidden() {
        this.busy = false
        this.error = null
        this.operation = null
      },
      onSave(e) {
        e.preventDefault()
        if (this.operation == 'disable') {
          this.disableLocation()
        }
        else if (this.operation == 'enable') {
          this.enableLocation()
        }
      },
      disableLocation() {
        this.busy = true
        this.error = null
        let url = `/organization/${this.organization.id}/location/${this.location.id}/disable`
        axios.post(url, {
          disabled_title: this.disabled_title,
          disabled_note: this.disabled_note,
          disabled_end: this.end,
        })
        .then(response => {
          this.busy = false
          this.$emit('location', response.data)
          this.$bvModal.hide(this.id)
        })
        .catch(error => {
          this.busy = false
          this.error =_.errorFromAjax(error)
        })
      },
      enableLocation() {
        this.busy = true
        this.error = null
        let url = `/organization/${this.organization.id}/location/${this.location.id}/enable`
        axios.post(url)
        .then(response => {
          this.busy = false
          this.$emit('location', response.data)
          this.$bvModal.hide(this.id)
        })
        .catch(error => {
          this.busy = false
          this.error =_.errorFromAjax(error)
        })
      },
    },
    mounted() {
      window.locationStateModal = this
    },
  }
</script>